import { ComponentProps } from 'react';
import { sub, startOfDay, endOfDay } from 'date-fns';

import { Volume } from '~/shared/types/api';
import { convertToGIB } from '~/shared/utils/formatNumber';
import Tag from '~/shared/components/Tag';

export const statusToTagVariantMap: {
  [k in Volume['monitoring']]: ComponentProps<typeof Tag>['variant'];
} = {
  Managed: 'green',
  Migrating: 'green',
  Unmonitored: 'gray',
  Unmanaged: 'gray',
  Unmigrating: 'gray',
  Growing: 'purple',
  Shrinking: 'purple',
  Merging: 'purple',
  Unattached: 'dark-blue',
  Deleted: 'dark-blue',
  Monitored: 'cyan',
};

export const refetchIntervalMs = 5000;

export function getProvisionedUtilization(volume?: Volume) {
  const { diskUsed, diskSize } = volume || {};

  const utilizationPercent = diskSize && diskUsed ? Math.round((diskUsed / diskSize) * 100) : 0;

  return `${utilizationPercent}% (${convertToGIB(diskUsed || 0)})`;
}

export function getDatafyUtilization(volume?: Volume) {
  const { diskUsed, datafyDiskSize } = volume || {};

  const utilizationPercent =
    datafyDiskSize && diskUsed ? Math.round((diskUsed / datafyDiskSize) * 100) : 0;

  return `${utilizationPercent}% (${convertToGIB(diskUsed || 0)})`;
}

export const dateFilters = [
  {
    title: 'Last hour',
    filter: {
      start_date: sub(new Date(), { hours: 1 }).toISOString(),
      end_date: new Date().toISOString(),
    },
  },
  {
    title: 'Last 3 hours',
    filter: {
      start_date: sub(new Date(), { hours: 3 }).toISOString(),
      end_date: new Date().toISOString(),
    },
  },
  {
    title: 'Last day',
    filter: {
      start_date: sub(new Date(), { days: 1 }).toISOString(),
      end_date: new Date().toISOString(),
    },
  },
  {
    title: 'Last week',
    filter: {
      start_date: startOfDay(sub(new Date(), { weeks: 1 })).toISOString(),
      end_date: endOfDay(new Date()).toISOString(),
    },
  },
  {
    title: 'Last month',
    filter: {
      start_date: startOfDay(sub(new Date(), { months: 1 })).toISOString(),
      end_date: endOfDay(new Date()).toISOString(),
    },
  },
];

export function getFilterSearchParams(
  filters: {
    field: 'monitoring' | 'sourceVolume' | 'volumeId' | 'instanceId' | 'diskType';
    value: string;
    op: 'equals';
  }[]
) {
  return [
    ...filters.map(({ field, value, op }) => ['filters', JSON.stringify({ field, value, op })]),
  ];
}
